<template>
  <div id="treeWrap">
    <div style="padding: 10px" v-if="sousuo">
      <Input
        v-model="keyword"
        placeholder="搜索节点"
        @on-search="searchGroup"
        search
      />
    </div>

    <div
      :class="'treeHeight' + height"
      class="treeHeight gundongtiao"
      id="monitorTreeTop"
      ref="monitorTreeTop"
    >
      <Tree
        :data="treeData"
        ref="tree"
        :show-checkbox="isMore"
        :check-strictly="false"
        :check-directly="false"
        select-node
        @on-select-change="selectFleet"
        @on-check-change="selectAlot"
      ></Tree>
    </div>
    <Row v-if="zsgc" :gutter="4" style="margin-top: 10px; padding: 0 15px">
      <Col span="8"
        ><Button
          size="small"
          title="新增一级节点"
          type="primary"
          @click="clickOpenGroup"
          long
          >新增</Button
        ></Col
      >
      <Col span="8"
        ><Button size="small" type="success" @click="zhankaishouqi" long>{{
          expandAll ? "收起" : "展开"
        }}</Button></Col
      ><Col span="8"
        ><Button size="small" type="warning" @click="clickCopy" long
          >复制</Button
        ></Col
      >
    </Row>
    <Row id="treeBtn" v-if="btn != undefined">
      <Col span="24"
        ><Button
          long
          type="primary"
          :disabled="grouopArr.length == 0"
          @click="queding"
          >确定</Button
        ></Col
      >
    </Row>

    <form-model
      :title="isAdd ? '新增数据' : '编辑数据'"
      width="700"
      ref="formModel"
    >
      <Input
        v-model="item.customer"
        @on-focus="openForm = true"
        slot="customer"
        readonly
      ></Input>
      <Button slot="btn" @click="openPiliang">批量更新客户</Button>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <form-model
      title="批量更新该节点（含子节点）客户"
      width="400"
      ref="plformModel"
    >
      <Input
        v-model="item.customer"
        @on-focus="openForm = true"
        slot="customer"
        readonly
      ></Input>
      <Button slot="btn" type="primary" @click="addUpdateCid">确定更新</Button>
    </form-model>
    <Modal v-model="openForm" fullscreen title="选择客户" footer-hide>
      <wuliukehuguanli :scan="true" @obj="reobj"></wuliukehuguanli>
    </Modal>
    <Drawer v-model="copyForm" width="600" placement="left">
      <Row style="height: 100%">
        <Col span="12" style="height: 100%"
          ><h3>第一步：选择源节点</h3>
          <div class="dsgseddg">
            <Tree :data="nowTreeData" @on-select-change="selectOrg"></Tree>
          </div>
        </Col>
        <Col span="12" style="height: 100%">
          <h3>第二步：选择目标节点</h3>
          <div class="dsgseddg">
            <Tree
              :data="treeData"
              ref="dsgcw"
              select-node
              @on-select-change="selectCopy"
            ></Tree>
          </div>

          <Button
            type="primary"
            long
            @click="copyOk"
            :disabled="copyItem.toId == 0 || copyItem.id == 0"
            >开始复制</Button
          >
        </Col>
      </Row>
    </Drawer>
  </div>
</template>
<script>
import wuliukehuguanli from "../wuliukehuguanli.vue";
export default {
  props: ["isMore", "btn", "idList", "sousuo", "height", "filterGroup"],
  components: { wuliukehuguanli },
  data() {
    return {
      keyword: "",
      openForm: false,
      copyForm: false,
      treeData: [],
      isAdd: true,
      zsgc: true,
      groupTitle: "",
      nowTreeData: [],
      item: {
        name: "",
        pid: "0",
        nodeType: "0", //0 -属性节点，1-分组节点)
        sort: 1,
        customer: "",
        cid: 0,
        label: "应收",
      },
      forms: [
        {
          title: "节点名称",
          key: "name",
          required: true,
          type: "Input",
        },
        {
          title: "节点类型",
          key: "nodeType",
          required: true,
          type: "Select1",
          st: "nodeType",
        },
        {
          title: "所属客户",
          key: "cid",
          key1: "customer",
          slotForm: "customer",
          required: false,
        },
        {
          title: "标签",
          key: "label",
          type: "Select",
          selectItems: ["应收", "应付"],
        },
        {
          title: "序号",
          key: "sort",
          required: true,
          type: "InputNumber",
        },
      ],
      plforms: [
        {
          title: "所属客户",
          key: "cid",
          key1: "customer",
          slotForm: "customer",
          required: true,
          span: 24,
        },
      ],
      grouopArr: [], //选择到的组，点击确定用到
      copyItem: {
        id: 0,
        toId: 0,
      },
      expandAll: true,
    };
  },
  methods: {
    getList() {
      var filter = this.filterGroup;
      this.axios({
        method: "post",
        url:
          this.axios.ipPort + "/cloud-tms-server-base/costTemplet/treePerson",
        data: {},
      }).then((res) => {
        this.data = [];
        var that = this;
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        }
        var data = res.data.data;
        if (data.length == 0) {
          this.$emit("fleetObj");
          return;
        }
        var that = this;
        function treedata2(kkk) {
          var newTree = kkk;
          return newTree.map((v) => {
            if (v.childList.length > 0) {
              v.childList = treedata2(v.childList);
            }
            v.title = v.name;
            v.groupId = v.id;
            v.nodeType = String(v.nodeType);
            v.expand = that.expandAll;
            v.checked = false;
            v.selected = false;
            v.seaarchGoal = false;
            v.children = v.childList;
            v.render = function (h) {
              return h(
                "div",
                {
                  class: { seaarchGoal: v.seaarchGoal, baojiaItem: true },
                  attrs: {
                    id: "box" + v.id,
                  },
                },
                [
                  h("span", v.name),
                  // h("span", "(" + 123 + "台)"),
                  h(
                    "span",
                    {
                      class: "control",
                      style: {
                        display: that.zsgc ? "inline-block" : "none",
                      },
                    },
                    [
                      /* h("Icon", {
                        props: { type: "md-copy" },
                        attrs: {
                          title: "复制节点",
                        },
                        on: {
                          click: (e) => {
                            that.clickCopy(v);
                            e.stopPropagation();
                          },
                        },
                      }), */
                      h("Icon", {
                        props: { type: "md-add" },
                        attrs: {
                          title: "新增下级节点",
                        },
                        on: {
                          click: (e) => {
                            that.clickAdd(v);
                            e.stopPropagation();
                          },
                        },
                      }),
                      h("Icon", {
                        props: { type: "md-checkmark-circle-outline" },
                        attrs: {
                          title: "编辑",
                        },
                        on: {
                          click: (e) => {
                            that.clickUpdate(v);
                            e.stopPropagation();
                          },
                        },
                      }),
                      h("Icon", {
                        props: { type: "md-close" },
                        attrs: {
                          title: "删除",
                        },
                        on: {
                          click: (e) => {
                            that.delFleet(v);
                            e.stopPropagation();
                          },
                        },
                      }),
                    ]
                  ),
                ]
              );
            };

            return v;
          });
        }

        this.treeData = treedata2(data);
      });
    },
    getListOrg() {
      var filter = this.filterGroup;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/costTemplet/tree",
        data: {},
      }).then((res) => {
        this.data = [];
        var that = this;
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        }
        var data = res.data.data;
        if (data.length == 0) {
          this.$emit("fleetObj");
          return;
        }
        var that = this;
        function treedata2(kkk) {
          var newTree = kkk;
          return newTree.map((v) => {
            if (v.childList.length > 0) {
              v.childList = treedata2(v.childList);
            }
            v.title = v.name;
            v.groupId = v.id;
            v.nodeType = String(v.nodeType);
            v.expand = that.expandAll;
            v.checked = false;
            v.selected = false;
            v.seaarchGoal = false;
            v.children = v.childList;
            v.render = function (h) {
              return h(
                "div",
                {
                  class: { seaarchGoal: v.seaarchGoal, baojiaItem: true },
                  attrs: {
                    id: "box" + v.id,
                  },
                },
                [
                  h("span", v.name),
                  // h("span", "(" + 123 + "台)"),
                  h(
                    "span",
                    {
                      class: "control",
                      style: {
                        display: that.zsgc ? "inline-block" : "none",
                      },
                    },
                    [
                      h("Icon", {
                        props: { type: "md-copy" },
                        attrs: {
                          title: "复制节点",
                        },
                        on: {
                          click: (e) => {
                            that.clickCopy(v);
                            e.stopPropagation();
                          },
                        },
                      }),
                      h("Icon", {
                        props: { type: "md-add" },
                        attrs: {
                          title: "新增下级节点",
                        },
                        on: {
                          click: (e) => {
                            that.clickAdd(v);
                            e.stopPropagation();
                          },
                        },
                      }),
                      h("Icon", {
                        props: { type: "md-checkmark-circle-outline" },
                        attrs: {
                          title: "编辑",
                        },
                        on: {
                          click: (e) => {
                            that.clickUpdate(v);
                            e.stopPropagation();
                          },
                        },
                      }),
                      h("Icon", {
                        props: { type: "md-close" },
                        attrs: {
                          title: "删除",
                        },
                        on: {
                          click: (e) => {
                            that.delFleet(v);
                            e.stopPropagation();
                          },
                        },
                      }),
                    ]
                  ),
                ]
              );
            };

            return v;
          });
        }

        this.nowTreeData = treedata2(data);
      });
    },
    addUpdate() {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url:
            this.axios.ipPort + "/cloud-tms-server-base/costTemplet/addPerson",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-base/costTemplet/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    zhankaishouqi() {
      this.expandAll = !this.expandAll;
      afc(this.treeData, this.expandAll);
      function afc(data, expand) {
        for (let i = 0; i < data.length; i++) {
          data[i].expand = expand;
          if (data[i].children.length > 0) {
            afc(data[i].children, expand);
          }
        }
      }
    },
    clickOpenGroup() {
      this.isAdd = true;
      this.item.pid = 0;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openPiliang() {
      this.$refs.plformModel.reach(this.plforms, this.item);
    },
    addUpdateCid() {
      console.log(this.item.id);
      console.log(this.item.cid);
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-base/costTemplet/treeUpdateCid",
        data: this.item,
      }).then((res) => {
        if (res) {
          this.$refs.plformModel.close();
          this.$refs.formModel.close();
          this.getList();
        }
      });
    },
    delFleet(row) {
      let params = {
        idList: [row.id],
      };
      this.$Modal.confirm({
        title: "此操作将会导致主业务数据丢失，请确认是否进行删除操作？",
        cancelText: "取消删除",
        okText: "仍要删除",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-base/costTemplet/del",
            data: params,
          }).then((res) => {
            if (res) {
              this.$refs.formModel.close();
              this.getList();
            }
          });
        },
      });
    },
    clickCopy(r) {
      this.copyForm = true;
      //this.nowTreeData = [r];
      this.getListOrg();
      //this.copyItem.id = r.id;
    },
    selectOrg(x, y) {
      if (y.selected) {
        this.copyItem.id = y.id;
      } else {
        this.copyItem.id = 0;
      }
    },
    selectCopy(x, y) {
      if (y.selected) {
        this.copyItem.toId = y.id;
      } else {
        this.copyItem.toId = 0;
      }
    },
    copyOk() {
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-base/costTemplet/treeCopyPerson",
        data: this.copyItem,
      }).then((res) => {
        if (res) {
          this.copyForm = false;
          this.getList();
          this.copyItem.id = 0;
          this.copyItem.toId = 0;
        }
      });
    },
    clickAdd(r) {
      this.isAdd = true;
      this.item.pid = r.id;
      this.$refs.formModel.reach(this.forms, this.item);
      let result = [];
      this.findParent(this.treeData, r, result);

      var t = result[0];
      this.item.cid = t.cid;
      this.item.customer = t.customer;
    },
    clickUpdate(r) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(r));
      this.$refs.formModel.reach(this.forms, this.item);

      let result = [];
      this.findParent(this.treeData, r, result);
      var t = result[0];
      this.item.cid = t.cid;
      this.item.customer = t.customer;
    },
    cliclCancelBtn() {
      this.openGroup = false;
    },
    selectFleet(x, y) {
      this.$emit("group", y, x);
      this.grouopArr = x;
      ddd(this.treeData);
      function ddd(t) {
        for (const i in t) {
          t[i].checked = false;
          t[i].seaarchGoal = false;
          if (t[i].children) {
            ddd(t[i].children);
          }
        }
      }
      let result = [];
      this.findParent(this.treeData, y, result, []);
      var m0 = [];
      for (let i = 0; i < result.length; i++) {
        m0.push(result[i].name);
      }
      var m = m0.join("_");
      var obj = {
        id: y.id,
        name: m,
      };
      this.$emit("abc", obj);
    },

    //data：要遍历的数据， target：查找目标， result用于装查找结果的数组
    findParent(data, target, result) {
      for (let i in data) {
        let item = data[i];
        if (item.id === target.id) {
          //将查找到的目标数据加入结果数组中
          //可根据需求unshift(item.id)或unshift(item)
          result.unshift(item);
          return true;
        }
        if (item.children && item.children.length > 0) {
          let ok = this.findParent(item.children, target, result);
          if (ok) {
            result.unshift(item);
            return true;
          }
        }
      }
      //走到这说明没找到目标
      return false;
    },
    //选择多个组
    selectAlot(x) {
      this.$emit("groups", x);
      ddd(this.treeData);
      function ddd(t) {
        for (const i in t) {
          t[i].selected = false;
          t[i].seaarchGoal = false;
          if (t[i].children) {
            ddd(t[i].children);
          }
        }
      }
    },
    queding() {
      this.$emit("queding", this.grouopArr);
    },
    quxiao() {},
    //监听外部搜索，比如车辆定位那里搜索
    look(key) {
      this.keyword = key;
      if (this.keyword.length > 0) {
        this.searchGroup();
      } else {
        this.getList();
      }
    },
    searchGroup() {
      this.treeData = this.fineCurrentIdRecursive(this.treeData);
    },
    fineCurrentIdRecursive(list) {
      for (const i in list) {
        // if (list[i].id === this.currentId) {
        if (list[i].title.indexOf(this.keyword) != -1) {
          list[i].seaarchGoal = true; //如果节点id等于currentId，则选中该节点
          setTimeout(() => {
            // var a = document.getElementById("box" + list[i].id).offsetTop;
            var a = document.getElementById("box" + list[i].id).offsetTop;
            this.$refs.monitorTreeTop.scrollTop = a;
          }, 500);
          break;
        } else {
          list[i].expand = false;
          list[i].selected = false;
          list[i].children = this.fineCurrentIdRecursive(list[i].children); //找不到想要的节点则继续找孩子的（递归）
          for (const j in list[i].children) {
            if (list[i].children[j].seaarchGoal || list[i].children[j].expand) {
              list[i].expand = true; //如果子节点（末端节点）选中或者子节点（非末端节点）展开，则展开该子节点的父节点
            }
          }
        }
      }
      return list;
    },
    reobj(v) {
      this.openForm = false;
      this.item.cid = v.id;
      this.item.customer = v.name;
    },
  },
  mounted() {
    this.getList();
  },
  watch: {
    copyForm(v) {
      this.zsgc = !v;
    },
  },
};
</script>
<style lang="">
#treeWrap {
  height: 100%;
}
#treeWrap .seaarchGoal {
  background: #fdd9d9;
}
#monitorTreeTop {
  position: relative;
  top: 0;
  left: 0;
  overflow-x: hidden;
}
#treeWrap .treeHeight {
  height: calc(100%);
}
#treeWrap .treeHeight30 {
  height: calc(100% - 30px);
}
#treeWrap .treeHeight40 {
  height: calc(100% - 40px);
}
#treeWrap .treeHeight60 {
  height: calc(100% - 60px);
}
#treeWrap .treeHeight90 {
  height: calc(100% - 90px);
}
#treeWrap .treeHeight100 {
  height: calc(100% - 100px);
}
#treeWrap .treeHeight120 {
  height: calc(100% - 120px);
}
#treeWrap .treeHeight180 {
  height: calc(100% - 180px);
}
#treeBtn {
  padding: 20px;
}
.baojiaItem {
  min-width: 160px;
  height: 20px;
  position: relative;
}
.baojiaItem span {
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.baojiaItem:hover .control {
  width: 120px;
}
.baojiaItem .control {
  padding: 4px 0px 4px 4px;
  width: 0;
  position: absolute;
  right: 0;
  top: -4px;
  background: #fff;
  transition: width 0.6s, padding 0.6s;
}

.control i {
  font-size: 16px;
  margin-right: 6px;
  color: #468ffd;
}
/*提示框信息 */
#tooltip_ul {
  padding: 10px;
  line-height: 1;
}
#tooltip_ul li {
  margin-bottom: 10px;
}
#tooltip_ul li h3 {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 0;
  color: #fff;
}
#tooltip_ul li p {
  margin-top: -4px;
  color: #fff;
}
.dsgseddg {
  overflow: auto;
  height: calc(100% - 60px);
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojiamubanLeftPerson.vue